import { useEffect } from 'react';
import Lenis from 'lenis';
import { ScrollTrigger } from '../hooks/gsap-init';
import { gsap } from '../hooks/gsap-init';

export const useSmoothScroll = () => {
    useEffect(() => {
        // Respect user preference for reduced motion
        const prefersReducedMotion = window.matchMedia(
            '(prefers-reduced-motion: reduce)'
        ).matches;

        if (prefersReducedMotion) return;

        const lenis = new Lenis({
            duration: 1.2,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            orientation: 'vertical',
            gestureOrientation: 'vertical',
            smoothWheel: true,
            wheelMultiplier: 1,
            touchMultiplier: 2,
        });

        // Connect Lenis to ScrollTrigger
        lenis.on('scroll', ScrollTrigger.update);

        // Expose lenis to window for global access/control
        // @ts-ignore
        window.lenis = lenis;

        // Use GSAP ticker for smooth animation loop
        gsap.ticker.add((time: number) => {
            lenis.raf(time * 1000);
        });
        gsap.ticker.lagSmoothing(0);

        // Handle anchor links
        const handleAnchorClick = (e: MouseEvent) => {
            const target = e.target as HTMLElement;
            const anchor = target.closest('a');
            if (anchor && anchor.getAttribute('href')?.startsWith('#')) {
                e.preventDefault();
                const href = anchor.getAttribute('href');
                if (href && href !== '#') {
                    const targetEl = document.querySelector(href);
                    if (targetEl) {
                        lenis.scrollTo(targetEl as HTMLElement, {
                            offset: -80,
                        });
                    }
                }
            }
        };

        document.addEventListener('click', handleAnchorClick);

        return () => {
            lenis.destroy();
            // @ts-ignore
            window.lenis = null;
            document.removeEventListener('click', handleAnchorClick);
            gsap.ticker.remove(lenis.raf);
        };
    }, []);
};
